// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
require('./_set-collection-of')('WeakSet');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es7.weak-set.of.js
// module id = 1560
// module chunks = 1